import { forwardRef, useMemo } from 'react';
import { Platform } from 'react-native';
import { Mobile } from './Mobile';
import Web from './Web';
import { generateSeries } from '../helper';

const CustomWebView = forwardRef(function CustomWebView(
  {
    individualStatsData,
    timeSeriesData,
    appDisplayName,
    setType,
    webViewTitle,
  },
  ref,
) {
  // Variables
  const isWebPlatform = Platform.OS === 'web' ? true : false;
  const generatedTimeSeries = useMemo(() => {
    return generateSeries(timeSeriesData);
  }, [timeSeriesData]);

  if (!individualStatsData || !generatedTimeSeries) return null;

  return isWebPlatform ? (
    <Web
      ref={ref}
      webViewTitle={webViewTitle}
      setType={setType}
      appDisplayName={appDisplayName}
      individualStatsData={individualStatsData}
      generatedTimeSeries={generatedTimeSeries}
    />
  ) : (
    <Mobile
      webViewTitle={webViewTitle}
      setType={setType}
      appDisplayName={appDisplayName}
      individualStatsData={individualStatsData}
      generatedTimeSeries={generatedTimeSeries}
    />
  );
});

export default CustomWebView;
